import React from "react";
import "./PrivacyPolicy.css";

export function PrivacyPolicy() {
  return (
    <div className="tnc__main">
      <h1 className="tnc__header">Privacy Policy</h1>
      <p className="tnc__content">
        We believe in the importance of being able to control who gets what
        information. This not only means you want your coworker to have your
        work email, and your friend to have your personal phone number, but it
        also means there are people who shouldn’t have any of your information.
      </p>
      <p className="tnc__content">
        We've made several choices in how “Searates Connect” is built to ensure
        only the people you choose to share with get the details you choose to
        share.
      </p>
      <p className="tnc__content">
        This Privacy Policy sets forth Searates Connect’s (“Searates Connect”,
        “we”, “us”, or “our”) privacy practices in connection with Searates
        Connect’s website located at https://theintechgroup.com/ (the “Site”)
        and the “Searates Connect” mobile applications (collectively, the
        “Service”). This Privacy Policy applies only to information collected by
        “Searates Connect” from users of our Services and visitors of our
        websites. Access to the Services is provided pursuant to the Terms of
        Service. Capitalized terms used but not defined in this Privacy Policy,
        shall have the meaning set forth in the Terms of Service.
      </p>
      <p className="tnc__content">
        Please read the following carefully to understand how we will collect,
        use, and maintain your personal information. It also describes your
        choices regarding the use, access, and correction of your personal
        information.
      </p>
      <p className="tnc__content">The “Searates Connect” Service</p>
      <p className="tnc__content">
        “Searates Connect” organizes and provides efficient means to access and
        receive updates regarding your contacts, and to share your own
        information with your contacts. The “Searates Connect” Service may
        additionally connect with third party software platforms which you have
        authorized to connect with “Searates Connect” (“Third Party Platforms”).
      </p>
    </div>
  );
}
